module.exports = __webpack_public_path__ + "img/nocont.e361c4b1.png";